import "core-js/modules/es.error.cause.js";
import { uploadFile, addUnit, editUnit } from './request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  data() {
    return {
      dialogVisible: false,
      currentRow: {},
      dataFrom: {
        name: '',
        abbreviation: '',
        logo: '',
        disclosurePageName: '',
        disclosurePageLink: '',
        icpNo: '',
        icpLink: ''
      },
      isDisclosureLink: false,
      isIcpLink: false,
      action: uploadFile,
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      imageUrl: '',
      loading: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('承保单位')
        }],
        abbreviation: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('单位简称')
        }],
        // disclosurePageName: [{min: 0, max: 40, message: this.$t('最多输入40个字'), trigger: 'change'}],
        disclosurePageName: [{
          required: this.isDisclosureLink,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('披露页名称')
        }],
        disclosurePageLink: [{
          required: this.isDisclosureLink,
          validator: this.checkDisclosurePageLink,
          trigger: 'change'
        }, {
          pattern: /^(?:(?:(?:https?|ftp):)?\/\/)?(?:[a-zA-Z0-9-]\.)?([a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/,
          message: '请输入正确的链接',
          trigger: 'blur'
        }],
        icpNo: [{
          required: this.isIcpLink,
          trigger: 'blur',
          message: this.$t('请输入icp备案号')
        }],
        icpLink: [{
          required: this.isIcpLink,
          validator: this.checkIcpLink,
          trigger: 'change'
        }, {
          pattern: /^(?:(?:(?:https?|ftp):)?\/\/)?(?:[a-zA-Z0-9-]\.)?([a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/,
          message: '请输入正确的链接',
          trigger: 'blur'
        }]
      };
    },
    checkDisclosurePageLink() {
      return (rule, value, callback) => {
        if (this.isDisclosureLink) {
          if (value == '') {
            callback(new Error(this.$t('请输入披露页链接')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    checkIcpLink() {
      return (rule, value, callback) => {
        if (this.isIcpLink) {
          if (value == '') {
            callback(new Error(this.$t('请输入icp备案号链接')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    }
  },
  methods: {
    init(data) {
      console.log(data);
      if (data.id) {
        this.dataFrom = Object.assign({}, this.dataFrom, data);
        this.isDisclosureLink = this.dataFrom.disclosurePageLink != '' ? true : false;
        this.isIcpLink = this.dataFrom.icpLink != '' ? true : false;
      }
      this.currentRow = data;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.currentRow.id ? editUnit : addUnit;
          if (this.currentRow.unitId) {
            this.dataFrom.unitId = this.currentRow.unitId;
          }
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
          });
        }
      });
    },
    // 上传限制
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请按正确格式上传logo'));
      }
      const isLt300kb = file.size / 1024 < 300;
      if (!isLt300kb) {
        this.$message.error(this.$t('上传文件超过300kb'));
      }
      return isJpgOrPng && isLt300kb;
    },
    handleChange({
      file
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (file.status === 'done') {
        this.dataFrom.logo = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        this.loading = false;
      }
    },
    disclosureChange(e) {
      this.isDisclosureLink = e.target.checked;
      this.dataFrom.disclosurePageLink = '';
    },
    icpChange(e) {
      this.isIcpLink = e.target.checked;
      this.dataFrom.icpLink = '';
    },
    // 去除前后空格
    handleBlurTrim(name, e) {
      this.dataFrom[name] = e.target.value.trim();
    }
  }
};